import { Result } from 'antd';
import { SmileOutlined } from '@ant-design/icons';

 const NoData = () => {
  return (
    <Result
    icon={<SmileOutlined />}
    title="Okunmamış duyurunuz bulunmamaktadır."
    />
  );
};

export default NoData;
